import { InjectionToken, Signal } from '@angular/core';

/**
 * Contract for right sidenav (My tasks / Chat) open state.
 * Implemented by layout; consumed by permission badge directive to hide badges when they overlap the panel.
 */
export interface RightSidenavState {
  isOpened(): boolean;
  readonly opened: Signal<boolean>;
}

export const RIGHT_SIDENAV_STATE = new InjectionToken<RightSidenavState>(
  'RIGHT_SIDENAV_STATE'
);
